import {
  SET_LANGUAGE_ROWS,
  SET_LOCALE_ORDER,
  ADD_LANGUAGE,
  DELETE_LANGUAGE,
  UPDATE_LANGUAGE_CELL,
  OPEN_ADD_LANGUAGE_MODAL,
  CLOSE_ADD_LANGUAGE_MODAL,
} from './types';

export const setLanguageRows = (payload) => ({ type: SET_LANGUAGE_ROWS, payload });
export const setLocaleOrder = (payload) => ({ type: SET_LOCALE_ORDER, payload });
export const addLanguage = (payload) => ({ type: ADD_LANGUAGE, payload });
export const deleteLanguage = (payload) => ({ type: DELETE_LANGUAGE, payload });
export const updateLanguageCell = (payload) => ({ type: UPDATE_LANGUAGE_CELL, payload });
export const openAddLanguageModal = () => ({ type: OPEN_ADD_LANGUAGE_MODAL });
export const closeAddLanguageModal = () => ({ type: CLOSE_ADD_LANGUAGE_MODAL });
